// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"99eff08c","103":"90f8dd01","264":"b3857df2","396":"cc8ff025","423":"845f9bef","561":"f71d65e7","706":"cbf6267f"}[chunkId] + ".chunk.css";
};